module.exports = __webpack_public_path__ + "static/media/mouse.d8078c80.png";